import { render, staticRenderFns } from "./SyncClock.vue?vue&type=template&id=591e5a36&"
import script from "./SyncClock.vue?vue&type=script&lang=js&"
export * from "./SyncClock.vue?vue&type=script&lang=js&"
import style0 from "./SyncClock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports